import {NgModule} from '@angular/core';
import {
    DcPageHierarchyTreeComponent
} from "./component/protected-components/dc-page-hierarchy-tree-component/dc-page-hierarchy-tree.component";
import {
    DcPageSearchComponent
} from "./component/protected-components/dc-page-search-component/dc-page-search.component";
import {DC_ENTITY_PROVIDER} from "./dc.entity-provider";
import {CoreModule} from "../../core/core.module";
import {DC_TEST_PROVIDERS} from "./test/dc-test-definition";
import {DcConfigComponent} from "./component/protected-components/dc-config/dc-config.component";
import {DcPageCreateComponent} from "./component/protected-components/dc-page-create/dc-page-create.component";
import {DcDocsPage} from "./page/overview/dc-config/dc-docs.page";
import {DcConfigPage} from "./page/overview/dc-config/dc-config.page";
import {
    DcPageContentObjectComponent
} from "./component/protected-components/dc-page-content-object/dc-page-content-object.component";
import {
    DcPageObjectComponent
} from "./component/object-components/dc-page-object-component/dc-page-object.component";

@NgModule({
    declarations: [
        DcPageHierarchyTreeComponent,
        DcPageSearchComponent,
        DcConfigComponent,
        DcConfigPage,
        DcPageCreateComponent,
        DcDocsPage,
        DcPageContentObjectComponent,
        DcPageObjectComponent,
    ],
    exports: [
        DcPageHierarchyTreeComponent,
        DcPageSearchComponent,
        DcPageCreateComponent,
        DcDocsPage,
        DcPageContentObjectComponent,
    ],
    imports: [
        CoreModule,
    ],
    providers: [DC_ENTITY_PROVIDER, DC_TEST_PROVIDERS]
})
export class DcModule {

}
